import { useState } from 'react';
import { Button, TextArea, Layer } from '@carbon/react';
import { useAtom } from 'jotai';
import { createCommentAtom } from '../events-panel/atoms';
import ErrorToast from 'components/error-toast';

import style from './comment-input.module.scss';

interface CommentInputProps {
  commentsHref: string;
  onSuccess?: () => void;
  disabled?: boolean;
  placeholder?: string;
  autoFocus?: boolean;
}

export const CommentInput = ({
  commentsHref,
  onSuccess,
  disabled = false,
  placeholder = 'Comment',
  autoFocus = false,
}: CommentInputProps) => {
  const [comment, setComment] = useState('');
  const [error, setError] = useState<string | undefined>();
  const [commentResult, createComment] = useAtom(createCommentAtom);

  const handleSubmit = () => {
    createComment({
      url: commentsHref,
      type: 'POST',
      data: { content: comment },
      onSuccess: () => {
        setComment('');
        setError(undefined);
        onSuccess?.();
      },
      onError: () => {
        setError('Failed to post comment');
      },
    });
  };

  return (
    <>
      <div className={style.input}>
        <Layer>
          <TextArea
            labelText="Comment"
            hideLabel
            placeholder={placeholder}
            autoFocus={autoFocus}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            disabled={disabled}
          />
        </Layer>
        <div className={style.buttons}>
          <Button
            type="submit"
            disabled={!comment || commentResult.loading || disabled}
            onClick={handleSubmit}
          >
            Post
          </Button>
        </div>
      </div>
      {error && <ErrorToast key={error} message={error} />}
    </>
  );
};
